import React, { useState } from "react"
import { FormattedMessage } from "react-intl"
import NewOrderModal from "../../../../order/NewOrderModal"
import AccountLimit from "../../../../state/account-limit/AccountLimit"
import GlobalHelper from "../../../GlobalHelper.jsx"
import Icon from "../../../icon/icon.component.jsx"
import ButtonWrapper from "../../../rich-text/feature-protection-wrappers/buttonProtectionWrapper.component"

interface OwnProps {
    accountLimits: AccountLimit
}

const OrderCreationButton = (props: OwnProps) => {
    const [openModal, setOpenModal] = useState<boolean>(false)

    const handleOpenModal = () => {
        setOpenModal(true)
    }

    const handleCloseModal = (id?: string) => {
        setOpenModal(false)

        if (id) {
            window.location.href = `/orders/${id}/edit`
        }
    }

    return (
        <>
            {openModal && (
                <NewOrderModal
                    onClose={handleCloseModal}
                />
            )}
            <ButtonWrapper
                message={
                    GlobalHelper.isAccountLimitExceeded(props.accountLimits.getDto())
                        ? <FormattedMessage
                            id="generic-listing.document-limit-exceeded"
                            defaultMessage="Documents limit exceeded."
                        /> 
                        : ""
                }
                onClick={handleOpenModal}
                className="btn btn-primary"
                protectedClassName="btn btn-primary"
                premium={false}
                protectionRule={!GlobalHelper.isAccountLimitExceeded(props.accountLimits.getDto())}>
                <span>
                    <Icon value="plus-circle" />
                    <FormattedMessage
                        id="generic-listing.orders.create-btn-text"
                        defaultMessage="New order"
                    />
                </span>
            </ButtonWrapper>
        </>
    )
}

export default OrderCreationButton


// WEBPACK FOOTER //
// ./src/common/listing/generic-listing/creation-buttons/OrderCreationButton.tsx